<template>
  <div>
    <v-page-toolbar :title="$t('_menu.settings')" icon="settings">
    </v-page-toolbar>

    <v-layout row wrap fluid>
      <v-flex>
        <Settings :value.sync="selectedGroup" />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Settings from "./Settings";;
import { mapActions, mapGetters } from "vuex";

export default {
  components: {Settings},
  data() {
    return {
      selectedGroup: null,
      dialog: false,
      itemIndex: -1,
      enabled: false,
      newItem: {
        categoryId: null,
        name: null,
        icon: null,
        parentId: null,
      },
    };
  },
  watch: {
    $route(to, from) {
      if (to == from) {
        console.log(to);
        console.log(from);
      }
    },
    deep: true,
    immediate: true,
  },
  computed: {
    ...mapGetters({ language: "app/language" }),
    lang() {
      return this.language.replaceAll("_", "-");
    },
  },
  methods: {
    onCancelled() {
      // hide a dialog
      this.dialog = false;
    },
    onConfirmed(editedItem) {
      // hide a dialog
      this.dialog = false;
      //this.refreshTable();
      // save a user and refresh a table
    },
  },
};
</script>